module.exports = __webpack_public_path__ + "static/media/User-white.b50951f3.svg";